export class ApiMethods {
    public static POST: string = 'post';
    public static GET: string = 'get';
    public static PUT: string = 'put';
    public static DELETE: string = 'delete';
}